import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getUser } from '../store/selectors/auth.selectors';
import { isLoading } from '../store/selectors/start.selectors';
import { State } from '../store/reducers';
import { applyAccessRedirect, normalizeRoutePath } from '../utils/access-redirect';

@Injectable({
  providedIn: 'root',
})
export class FremiumGuard implements CanActivate {
  constructor(private router: Router, private store: Store<State>) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const path = normalizeRoutePath(state.url);
    const publicRoutes = ['/login', '/fremium'];

    if (publicRoutes.includes(path)) {
      return true;
    }

    return combineLatest([
      this.store.select(getUser),
      this.store.select(isLoading),
    ]).pipe(
      filter(([user, loading]) => user !== undefined && !loading),
      take(1),
      map(([user]) => {
        if (!user) {
          return this.router.createUrlTree(['/login']);
        }

        if (!user.companies || user.companies.length === 0) {
          return this.router.createUrlTree(['/login']);
        }

        if (applyAccessRedirect(user, state.url)) {
          return false;
        }

        return true;
      })
    );
  }
}
